// extracted by mini-css-extract-plugin
export default {"messagingEmailContainer":"Messagingemail_messagingEmailContainer__ZVvjH","tabSection":"Messagingemail_tabSection__VPCv5"};